import { fetchApi } from '../utils/callBalancesPayablesApi';

export const CALL_BALANCES_PAYABLES_API = Symbol('callBalancesPayablesApi key');

// Action key that carries API call info interpreted by this Redux middleware.
const callKycApi = store => next => async (action) => {
    // console.log("next IN callApi MIDDLEWARE => ", next);
    // console.log("store IN callApi MIDDLEWARE => ", store);
    const apiRoutes = action[CALL_BALANCES_PAYABLES_API];

    // console.log('apiRoutes => ', apiRoutes);
    // If it's not a callApi's action skip to next action.
    if (typeof apiRoutes === 'undefined') {
        return next(action);
    }
    const state = store.getState()
    const env = state.appstate.environment
    const { method, types, params, reqBody, query } = action;
    // console.log(' WHAT TYPES: ', types);
    // console.log('params => ', params);
    // console.log('reqBody => ', reqBody);
    next({ type: types[0] });
    return fetchApi(env, apiRoutes, method, params, reqBody, query).then(
        response => next({
        data: response.data,
        type: types[1],
        }), error => next({
        error: (error && error.message) || 'Something bad happened',
        type: types[2]
        })
    )
}

export default callKycApi